var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArena = function SvgArena(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M106.991 40.062C106.457 18.96 87.421 2 64.014 2S21.023 19.449 21.023 40.971c0 15.694-.106 31.418.14 47.116C21.753 109.115 40.738 126 64.074 126s42.327-16.885 42.912-37.913H107v-48.03h-.014z"
  })));
};
export default SvgArena;